import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"depressed":"","color":"primary","loading":_vm.loading,"disabled":_vm.isNotRestockable},on:{"click":_vm.restock}},[_vm._v(" "+_vm._s(_vm.$t('Restock'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }